import { ConfigurationField, ENVIRONMENTS, IAnnotation } from "@bronte/viewer-api/src/main";
import { AnnotationTypes } from "./constants";
import { URLParams } from "./types";

export const getURLParams = (): URLParams => {
  const pathname = window.location.pathname.split("/");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return {
    cohortId: pathname[1],
    deploymentId: pathname[2],
    env: urlParams.get("env") || ENVIRONMENTS.QA,
    pocEnabled: urlParams.get("pocEnabled") || "",
    disableIES: urlParams.get("disableIES") || "",
    screenId: urlParams.get("screenId") || "",
    userId: urlParams.get("userId") || "",
    token: urlParams.get("token") || "",
    packagePath: urlParams.get("packagePath") || "",
  };
};

export const getAuthToken = (callback: (token: string) => void): void => {
  let token = getURLParams().token;

  if (!token) {
    window.piSession?.getToken(async (_status: string, pearsonToken: string) => {
      token = pearsonToken;
    });
  }

  callback(token);
};

export const getClientId = (): string => {
  return getURLParams().env === ENVIRONMENTS.PROD
    ? "hQ8ZsSZoIjyl8chQLgo7dB7fAlGIFvVG"
    : "oX5Vm6SEEeSi5QBEAU0081tx20UHE469";
};

export const getSessionJsURL = (): string => {
  const env = getURLParams().env;
  let sessionJsURL = "";
  switch (env) {
    case ENVIRONMENTS.PPE:
      sessionJsURL = "https://login-ppe.pearson.com/v1/piapi-pqa/login/js/v2/session.js";
      break;
    case ENVIRONMENTS.PROD:
      sessionJsURL = "https://login.pearson.com/v1/piapi/login/js/v2/session.js";
      break;
    default:
      sessionJsURL = "https://login-stg.pearson.com/v1/piapi-int/login/js/v2/session.js";
  }
  return sessionJsURL;
};

export const getTitle = (data: ConfigurationField[]): string =>
  data.find(({ fieldName }) => fieldName === "title")?.fieldValue || "";

// generate and return unique id when adding new notes/highlight
export const getUniqueIdForAnnotation = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

// Check if annotation is flash card
export const isFlashCard = (annotation: IAnnotation): boolean => {
  return annotation?.annotationType?.toLowerCase() === AnnotationTypes.FlashCard.toLowerCase();
};
